<template>
  <v-col class="register default-slot" md="7" sm="12">
    <div class="top-icons">
      <a class="back-icon" v-on:click="changePage(1)">
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1 class="register-title">Lease Agreement</h1>
    <v-row>
      <v-col>
        <h2>Select Date Range for Lease</h2>
        <v-alert
          class="mb-1 mt-1"
          v-if="validationInfo.errorMessage"
          type="error"
          >{{ validationInfo.errorMessage }}</v-alert
        >
        <v-date-picker v-model="dates" range></v-date-picker>
        <p>Start date: {{ dates[0] }}</p>
        <p>End date: {{ dates[1] }}</p>
      </v-col>
    </v-row>
    <v-btn
      class="white--text"
      large
      v-on:click="changePage(3)"
      :disabled="isDisabled"
      color="primary"
      >NEXT</v-btn
    >
    <p class="steps">STEP <b>2</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import FooterText from "@/components/common/FooterText.vue";

export default Vue.extend({
  components: { FooterText },
  name: "LeaseRequestForm2",
  data: function () {
    return {};
  },
  methods: {},
  watch: {
    dates: function (newVal: string[], oldVal: string[]) {
      if (newVal === oldVal) return;
      this.$props.changeDates(newVal);
    },
  },
  computed: {
    isDisabled: function () {
      return (
        this.dates[0] === "" ||
        this.dates[1] === "" ||
        !this.validationInfo.success
      );
    },
  },
  props: {
    changePage: Function,
    dates: Array,
    changeDates: Function,
    validationInfo: Object,
  },
});
</script>